import image1 from "./assets/image-slide-1.jpg";
import image2 from "./assets/image-slide-2.jpg";
import image3 from "./assets/image-slide-3.jpg";
import image4 from "./assets/image-slide-4.jpg";
import image5 from "./assets/image-slide-5.jpg";

const portfolio = [
  {
    id: 1,
    image: image1,
  },
  {
    id: 2,
    image: image2,
  },
  {
    id: 3,
    image: image3,
  },
  {
    id: 4,
    image: image4,
  },
  {
    id: 5,
    image: image5,
  },
];

export default portfolio;
